export const BETA_FEATURE_WHATSAPP = 'tracking_messages_whatsapp'
export const BETA_FEATURE_360_DIALOG = 'tracking_messages_whatsapp_360dialog'
export const TRUSTPILOT_VERIFIED_REVIEW = 'trustpilot_verified_review'
export const BETA_FEATURE_WA_CUSTOM_TEMPLATES = 'tracking_messages_whatsapp_custom_templates'
export const BETA_FEATURE_WA_POST_PURCHASE = 'tracking_messages_whatsapp_post_purchase'
